<template>
  <div class="book_infor p_t">
    <TopHead :title="ydInfo.title"></TopHead>
    <div class="bi_c">
      <!--<div class="f_title mb_20">{{ydInfo.title}}</div>-->
      <div v-html="ydInfo.contentInfo"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "BookInfor",
    data() {
      return {
        ydInfo:{},
        code:'',
      }
    },
    created(){
      this.code = this.$route.query.code || 'ydxz';
      this.queryContentByCode();
    },
    methods: {
      //查询预定须知
      queryContentByCode(){
        this.$api.queryContentByCode(this.code).then(res => {
          this.ydInfo = JSON.parse(JSON.stringify(res.data));
        })
      },
    }
  }
</script>

<style scoped lang="scss">
  .bi_c{
    padding: 20px 13px;
  }

</style>
